module.exports = __webpack_public_path__ + "static/media/t32.6ac72cce.png";